import { Component, OnInit } from '@angular/core';
import { StormService, SharedService } from './../../../services';
import { DomSanitizer } from '@angular/platform-browser';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
  selector: 'ticker-storm',
  templateUrl: './ticker-storm.component.html',
  styleUrls: ['./ticker-storm.component.scss']
})
export class TickerStormComponent implements OnInit {

  constructor(
    private _storm: StormService,
    private _shared: SharedService,
	private breakpointObserver: BreakpointObserver,
    private _sanitizer: DomSanitizer
  ) { }

  // @HostBinding('ngIf')
  // ngif: boolean = false;

  loading = false;
  data;
  time;
  screenWidth;
  //isSmallScreen = this.breakpointObserver.isMatched('(max-width: 1000px)');
  // showStorm;
  // res;
  // date;
  // date2;

  getTrueText(html) {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  checkAllDate(data) {
    let isStorm = data.some(v => new Date(v.end_date) > new Date());
    this._shared.changeStorm(isStorm);
    return isStorm;
  }

  checkDate(d) {
    return new Date(d) > new Date();
  }

  getCurrent() {
    this.loading = true;
    this._storm.getCurrent().subscribe(
      resCurr => {
		// Filters expired data by end_date
		const res = resCurr.filter(e => this.checkDate(e.end_date));
        this.data = res;
        this.time = (res.reduce((accumulator, v) => accumulator + v.text.length, 0) < 150)
          ? (res.reduce((accumulator, v) => accumulator + v.text.length, 0) / (this.screenWidth / 2)) * this.time
          : (res.reduce((accumulator, v) => accumulator + v.text.length, 0) / this.screenWidth) * this.time;
        if (res && res.length && res.length > 0) {
          this._shared.changeStorm(true);
        } else {
          this._shared.changeStorm(false);
        }
        this.loading = false;
      },
      err => {
        console.error(err);
        this._shared.changeStorm(false);
        this.loading = false;
      }
    )
  }

  ngOnInit() {
	// Используйте BreakpointObserver для отслеживания изменения ширины экрана
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small, // Маленький экран
      Breakpoints.Medium, // Средний экран
      Breakpoints.Large, // Большой экран
      Breakpoints.XLarge // Фикс для Firefox. В этом браузере Large не реагирует на ширину 1920px
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints[Breakpoints.XSmall]) {
          // Ширина экрана соответствует Small breakpoint
          this.time = 60 * (window.innerWidth / 1920); // Установите значение time для маленьких экранов
          this.screenWidth = window.innerWidth / 5;
        } else if (result.breakpoints[Breakpoints.Small]) {
          // Ширина экрана соответствует Small breakpoint
          this.time = 60 * (window.innerWidth / 1920); // Установите значение time для маленьких экранов
          this.screenWidth = window.innerWidth / 5;
        } else if (result.breakpoints[Breakpoints.Medium]) {
          // Ширина экрана соответствует Medium breakpoint
          this.time = 60 * (window.innerWidth / 1920); // Установите значение time для средних экранов
          this.screenWidth = window.innerWidth / 5;
        } else {
          // Ширина экрана соответствует отсальным экранам
          this.time = 60 * (window.innerWidth / 1920); // Установите значение time для больших экранов
          this.screenWidth = window.innerWidth / 8;
        }
      }
    });

    this.getCurrent();
  }

}
